var J = Object.defineProperty;
var b = (t, e, n) => e in t ? J(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var I = (t, e, n) => (b(t, typeof e != "symbol" ? e + "" : e, n), n);
import V from "lodash/isEmpty";
import H from "@bugsnag/js";
import { jwtDecode as G } from "jwt-decode";
import { v4 as K } from "uuid";
import { fromUnixTime as D, startOfMinute as Y, getUnixTime as W, differenceInMinutes as x } from "date-fns";
import z from "byte-size";
import q from "lodash/omit";
const X = (t) => G(t), g = () => {
  var t;
  return ((t = window.FoojiDevConfig) == null ? void 0 : t.FOOJI_DOMAIN) ?? "prod.fooji.com";
}, Z = () => "88ff4073d7d47838b19a5fe8b190b59a", Q = () => window.FoojiDevConfig ? "development" : "production", tt = () => {
  var t;
  return ((t = window.FoojiDevConfig) == null ? void 0 : t.FOOJI_MICROSITE_DOMAIN) ?? document.location.host;
};
var et = { FOOJI_DASHBOARD_SUBDOMAIN: "dash", FOOJI_AUTH_API_SUBDOMAIN: "auth-api", FOOJI_FRONTEND_SUBDOMAIN: "front-end-api", FOOJI_WS_SUBDOMAIN: "ws", FOOJI_LISTENER_SUBDOMAIN: "listener", FOOJI_SERVERLESS_FUNCTIONS_SUBDOMAIN: "functions", FOOJI_MODE: "live", FOOJI_MAX_UPLOAD_SIZE_BYTES: "6291456", FOOJI_MAX_WAITING_TIME_MINUTES: "3", FOOJI_PUBLIC_LIBRARY: "true", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const h = Q();
console.log("The current stage is: ", h);
const nt = {
  apiKey: Z(),
  // fooji-microsites-v2 api key
  appVersion: et.npm_package_version,
  releaseStage: h,
  enabledReleaseStages: ["production"],
  autoDetectErrors: h !== "test",
  redactedKeys: [
    // User details
    "first_name",
    "last_name",
    "email",
    "phone",
    "business",
    // Address
    "latitude",
    "longitude",
    "address1",
    "address2",
    "state",
    "zip",
    "country",
    "city",
    "place_id"
  ]
};
let E = null;
const rt = () => (E || (E = H.createClient(nt)), E), f = async (t) => {
  var s;
  const e = t.jwt ? X(t.jwt) : null, n = (e == null ? void 0 : e.fooji_data.campaign_user.campaign_key) ?? "Unknown campaign key", r = await ((s = t.response) == null ? void 0 : s.clone().json());
  console.log("Notifying Bugsnag with error: ", t.errorMessage), rt().notify(new Error(t.errorMessage), (o) => {
    const a = {
      campaign_key: n,
      ...t.additionalMetadata ?? {}
    };
    t.response && (a.response_status = t.response.status, a.response = r, t.response.status === 401 && (a.jwt = e)), t.error && (a.error = t.error), console.log("Adding metadata to Bugsnag event: ", a), o.addMetadata("error_details", a);
  });
};
class st extends Error {
  constructor(n, r = "Unsuccessful Response") {
    super(r);
    I(this, "response");
    this.name = "UnsuccessfulError", this.response = n;
  }
}
class p extends Error {
  constructor(n, r) {
    super(r);
    I(this, "response");
    this.name = "HttpError", this.response = n;
  }
}
const m = {
  getRequestAuthorization: (t) => {
    const e = t ? Object.fromEntries(new Headers(t == null ? void 0 : t.headers).entries()) : void 0;
    return e == null ? void 0 : e.Authorization;
  },
  guardedFetch: async (t, e) => {
    try {
      const n = await fetch(t, e), r = await n.clone().text(), s = V(r) ? null : JSON.parse(r);
      if (n.status === 404)
        throw new p(
          n,
          "Record not found. Please confirm your data and try again."
        );
      if (n.status === 429 || n.status === 403)
        throw new p(
          n,
          "You are making too many requests, please wait five minutes and try again."
        );
      if (n.status >= 400 && n.status < 500) {
        await f({
          /* eslint-disable-next-line @typescript-eslint/no-base-to-string */
          errorMessage: `Unhandled client error on call: ${t.toString()}`,
          response: n,
          jwt: m.getRequestAuthorization(e)
        });
        const {
          error: o = "Something went wrong. Please confirm your data and try again."
        } = await n.json();
        throw new p(n, o);
      } else {
        if (n.status >= 500)
          throw await f({
            /* eslint-disable-next-line @typescript-eslint/no-base-to-string */
            errorMessage: `Server error on call: ${t.toString()}`,
            response: n,
            jwt: m.getRequestAuthorization(e)
          }), new p(n, "Request failed. Please try again.");
        if ((s == null ? void 0 : s.success) === !1)
          throw new st(n, s == null ? void 0 : s.error);
        return n;
      }
    } catch (n) {
      throw n instanceof p || await f({
        /* eslint-disable-next-line @typescript-eslint/no-base-to-string */
        errorMessage: `Server error on call: ${t.toString()}`,
        error: n,
        jwt: m.getRequestAuthorization(e)
      }), n;
    }
  }
}, at = m.guardedFetch, ot = (t, e) => {
  throw t;
}, it = () => sessionStorage.getItem("jwt"), y = {
  authenticatedFetch: async (t, e, n, r = { "Content-Type": "application/json" }, s = {}) => {
    const o = `Bearer ${n || it()}`, a = {
      ...e,
      headers: {
        ...r,
        ...e == null ? void 0 : e.headers,
        Authorization: o
      }
    };
    return y.guardedFetch(t, a, s);
  },
  guardedFetch: async (t, e, n = {}) => {
    try {
      return await at(t, e);
    } catch (r) {
      return ot(r);
    }
  }
}, l = y.authenticatedFetch, _ = y.guardedFetch, c = {
  frontendBaseUrl: `https://front-end-api.${g()}`,
  authApiBaseUrl: `https://auth-api.${g()}`,
  wsBaseUrl: `https://ws.${g()}`,
  listenerBaseUrl: `https://listener.${g()}`,
  serverlessFunctionsBaseUrl: `https://functions.${g()}`
}, ct = async (t) => {
  const e = `${c.authApiBaseUrl}/me/addresses`;
  return await (await l(e, {
    method: "POST",
    body: JSON.stringify(t)
  })).json();
}, ut = async (t) => {
  const e = `${c.authApiBaseUrl}/me/addresses/${t.id}`;
  return await (await l(e, {
    method: "PUT",
    body: JSON.stringify(t)
  })).json();
}, lt = async (t) => (await (t != null && t.id ? ut : ct)(t)).address, dt = {
  createOrUpdate: (t) => lt(t)
}, C = () => {
  let t = localStorage.getItem("device_uuid");
  return t || (t = K(), localStorage.setItem("device_uuid", t)), t;
};
async function _t(t) {
  const e = `${c.frontendBaseUrl}/v1/campaign/anonymous/start`;
  return await (await _(e, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(t)
  })).json();
}
async function k(t, e) {
  const n = `${c.frontendBaseUrl}/v1/campaign?campaign_key=${t}&timestamp=${e}`;
  return await (await _(n, {
    method: "GET"
  })).json();
}
async function gt(t, e) {
  const n = `${c.frontendBaseUrl}/v1/campaign/is-valid?campaign_key=${t}&timestamp=${e}`;
  return await (await _(n, {
    method: "GET"
  })).json();
}
async function pt() {
  const t = `${c.frontendBaseUrl}/v1/campaign-user`;
  return await (await l(t, {
    method: "GET"
  })).json();
}
async function ft(t) {
  const e = `${c.frontendBaseUrl}/v1/campaign/continue`;
  return await (await l(e, {
    method: "POST",
    body: JSON.stringify({
      process_key: t
    })
  })).json();
}
async function mt(t) {
  const e = `${c.frontendBaseUrl}/v1/user/activate-workflow`;
  return await (await l(e, {
    method: "POST",
    body: JSON.stringify({
      address_id: t
    })
  })).json();
}
const Ot = ({
  campaign: t,
  processKey: e,
  fingerprint: n,
  channel: r
}) => {
  const s = {
    workflow_key: t.campaign_key,
    organization_id: t.organization_id,
    process_key: e,
    campaign_user: {
      campaign_key: t.campaign_key,
      channel: r,
      identifier: n,
      user_key: `${t.campaign_key}-${r}-${n}`
    }
  }, o = t.starts_at, a = t.ends_at;
  if (o && a) {
    const u = D(o).toISOString(), d = D(a).toISOString();
    s.period = `${u}/${d}`;
  }
  return s;
}, F = () => {
  const e = Y(/* @__PURE__ */ new Date());
  return W(e);
}, wt = (t, e) => Object.keys(t).filter((s) => s.startsWith(e)).reduce((s, o) => {
  const a = o.split("_"), u = parseInt(a.pop() || "", 10);
  return s === null || s < u ? u : s;
}, null), P = (t, e) => t[`${e}${wt(t, e)}`], It = (t) => P(t, "current_process_"), B = (t) => P(t, "current_phase_");
async function Et(t) {
  const e = `${c.authApiBaseUrl}/auth/anonymous`;
  return await (await _(e, {
    method: "POST",
    body: JSON.stringify(t)
  })).json();
}
async function St(t, e) {
  const n = `${c.authApiBaseUrl}/auth/${t}/start`;
  return await (await _(n, {
    method: "POST",
    body: JSON.stringify(e)
  })).json();
}
const ht = async (t) => new Promise((e) => setTimeout(e, t)), yt = 2e3, At = (t) => yt, Ut = "3", Nt = (t, e, n) => {
  const r = { stopPolling: !1 }, s = At(), d = {
    waitStart: t,
    pollerObject: r,
    delay: s,
    maxTime: Ut,
    allowInfinitePolling: !1,
    keepPollingOnError: !0,
    ...e,
    attempt: 0,
    useExponentialBackoff: !0
  };
  return (async () => await L.start(d))(), r;
}, L = {
  start: async ({
    waitStart: t,
    pollerObject: e,
    pollingFunction: n,
    delay: r,
    maxTime: s,
    allowInfinitePolling: o,
    keepPollingOnError: a,
    onPollingSuccess: u,
    timeOutHandler: d,
    attempt: U,
    useExponentialBackoff: O
  }) => {
    const j = x(/* @__PURE__ */ new Date(), t), N = {
      waitStart: t,
      pollerObject: e,
      pollingFunction: n,
      delay: r,
      maxTime: s,
      allowInfinitePolling: o,
      keepPollingOnError: a,
      onPollingSuccess: u,
      timeOutHandler: d,
      attempt: U,
      useExponentialBackoff: O
    };
    let w = !1;
    if (e.stopPolling)
      return;
    if (!o && j >= s) {
      d && await d();
      return;
    }
    const T = O ? r * Math.pow(2, N.attempt++) : r;
    console.log("Poller.start: ", { waitStart: t, delay: r, maxTime: s, attempt: U, waitDelay: T, useExponentialBackoff: O }), await ht(T);
    try {
      if (w = await n(), w)
        return u && u(w);
    } catch {
      if (!a)
        return;
    }
    await L.start(N);
  }
}, A = {
  get: async () => {
    const { campaign_user: t } = await pt();
    return t;
  }
}, Tt = {
  checkWorkflowStatus: async (t, e) => {
    const n = await A.get(), { current_status_updated_at: r } = n;
    return r !== e.timestamp ? (e.timestamp = r, t(n)) : !1;
  }
}, Dt = {
  promiseWrapper: (t) => new Promise((e, n) => t(e, n))
}, $ = async (t, e) => Dt.promiseWrapper((n, r) => {
  const s = { timestamp: e }, o = t(n, r);
  Nt(/* @__PURE__ */ new Date(), {
    pollingFunction: () => Tt.checkWorkflowStatus(o, s),
    timeOutHandler: () => {
      throw new Error("Workflow start timed out");
    }
  });
}), Rt = (t, e) => (n) => {
  const { current_status: r, metadata: s, status_reason: o } = n, a = B(s);
  return r === "finished" ? (a === "thank-you" && o === "link-used" && e(new Error("Link used")), t({ currentPhase: a, campaignUser: n }), !0) : r === "fatal-error" ? (e(new Error("Fatal workflow error")), !0) : !1;
}, Mt = (t) => ({
  fingerprint: C(),
  client: "microsite",
  workflow_key: t
}), vt = {
  anonymous: {
    start: async (t) => {
      const e = Mt(t), [{ process_key: n }, { result: r }] = await Promise.all([
        _t(e),
        k(t, F())
      ]), s = Ot({
        campaign: r,
        processKey: n,
        fingerprint: e.fingerprint,
        channel: "anonymous"
        // FIXME: Not supporting instagram-link? Maybe pass as param to start?
      }), { jwt: o } = await Et({
        fingerprint: e.fingerprint,
        fingerprint_description: window.navigator.userAgent,
        fooji_data: s,
        language: sessionStorage.getItem("language") || "en",
        client: e.client
      });
      return sessionStorage.setItem("jwt", o), $(Rt);
    }
  },
  activisionCOD: {
    start: async (t, e) => {
      const n = {
        return_to: e.toString(),
        fooji_data: {
          workflow_key: t
        },
        client: "microsite",
        fingerprint: C(),
        fingerprint_description: window.navigator.userAgent,
        language: sessionStorage.getItem("language") || "en"
      }, { redirect_url: r } = await St("callofduty", n);
      return r;
    }
  }
}, i = {
  CAMPAIGN_OVER: "/campaign-over",
  CAMPAIGN_TEASER: "/campaign-teaser",
  INVALID_CHANNEL: "/invalid-channel",
  SUCCESS: "/success",
  USER_DETAILS: "/user-details",
  CANCELLED: "/cancelled",
  ERROR: "/error",
  NO_OOJI_DATA: "/no-ooji-data",
  NO_SUPPORT: "/no-support",
  STOCK_OUT: "/stock-out",
  ALREADY_ORDERED: "/already-ordered",
  TOO_MUCH_DEMAND: "/too-much-demand",
  RATE_LIMIT: "/rate-limit",
  UNLUCKY: "/unlucky",
  LINK_USED: "/link-used",
  LINK_EXPIRED: "/link-expired",
  BOT_DETECTED: "/bot-detected",
  RESTRICTED_CAMPAIGN_INFO: "/restricted-campaign-info",
  TOO_YOUNG: "/too-young",
  ADDRESS: "/address-details",
  AUTHENTICATION_ERROR: "/authentication-error",
  RULES: "/rules",
  REVIEW_DETAILS: "/review",
  VERIFY_EMAIL: "/verify-email",
  MENU: "/menu",
  REMINDER: "/reminder",
  CHECK_AGE: "/check-age",
  SURVEY: "/survey",
  ENTRY_GATE: "/entry-gate",
  FOLLOW_UP_SURVEY: "/follow-up-survey",
  PROGRESS: "/progress",
  EMAIL_VERIFIED: "/email-verified",
  EMAIL_VERIFICATION_FAILED: "/email-verification-failed",
  INFO: "/info",
  EXTRA_INFO: "/extra-info",
  SKILL_TEST: "/skill-test",
  DELIVERY_ZONES: "/delivery-zones",
  UPLOAD_FILE: "/upload-file",
  SECONDARY_CHANNEL: "/secondary-channel",
  INVALID_ENTRY: "/invalid-entry"
}, Ct = {
  handler: (t, e) => {
    let n;
    switch (t) {
      case "supplier-rate-limited":
      case "rate-limited":
        n = i.TOO_MUCH_DEMAND;
        break;
      case "stock-out":
      case "no-quota":
        n = i.STOCK_OUT;
        break;
      case "no-suppliers":
      case "no-availability":
      case "unknown":
        n = i.NO_SUPPORT;
        break;
      case "unlucky":
        n = i.UNLUCKY;
        break;
      case "link-used":
        n = i.LINK_USED;
        break;
      case "campaign-over":
        n = i.CAMPAIGN_OVER;
        break;
      case "bot-detected":
        n = i.BOT_DETECTED;
        break;
      case "invalid-channel":
        n = i.INVALID_CHANNEL;
        break;
      case "invalid-entry":
        n = i.INVALID_ENTRY;
        break;
      default:
        n = i.CANCELLED;
    }
    e(n);
  }
}, R = {
  [i.TOO_MUCH_DEMAND]: "Too much demand",
  [i.STOCK_OUT]: "Out of stock",
  [i.NO_SUPPORT]: "No support",
  [i.UNLUCKY]: "Unlucky",
  [i.LINK_USED]: "Link used",
  [i.CAMPAIGN_OVER]: "Campaign over",
  [i.BOT_DETECTED]: "Bot detected",
  [i.INVALID_CHANNEL]: "Invalid channel",
  [i.INVALID_ENTRY]: "Invalid entry",
  [i.CANCELLED]: "Cancelled"
}, kt = {
  action: (t) => (e) => {
    const n = R[e] || R.default;
    t(new Error(`Workflow reached a bad status: ${n}`));
  }
}, Ft = (t, e) => (n) => {
  const { current_status: r, metadata: s, status_reason: o } = n, a = B(s);
  return r === "finished" ? (["thank-you", "thank-you-allow-repeat", "lucky-dip-phase", "duplicate-order"].includes(a) || a.startsWith("complete-order-") ? t({ currentPhase: a, campaignUser: n }) : Ct.handler(o, kt.action(e)), !0) : r === "fatal-error" ? (e(new Error("Fatal workflow error")), !0) : !1;
}, Pt = async (t, e) => {
  try {
    return await gt(t, e), !0;
  } catch {
    return !1;
  }
}, Bt = {
  getStatus: async (t) => {
    const e = F(), [{ result: n }, r] = await Promise.all([
      k(t, e),
      Pt(t, e)
    ]);
    return !(n != null && n.is_running) && !(n != null && n.has_ended) ? "teasing" : n != null && n.has_ended || !r ? "over" : "running";
  },
  enter: async (t) => {
    await mt(t);
    const e = await A.get(), n = e.current_status_updated_at, r = It(e.metadata);
    return await ft(r), $(Ft, n);
  }
};
async function Lt(t, e = {}) {
  const n = `${c.frontendBaseUrl}/v1/config/${t}`;
  return await (await _(n, {
    method: "GET"
  }, e)).json();
}
var S = { FOOJI_DASHBOARD_SUBDOMAIN: "dash", FOOJI_AUTH_API_SUBDOMAIN: "auth-api", FOOJI_FRONTEND_SUBDOMAIN: "front-end-api", FOOJI_WS_SUBDOMAIN: "ws", FOOJI_LISTENER_SUBDOMAIN: "listener", FOOJI_SERVERLESS_FUNCTIONS_SUBDOMAIN: "functions", FOOJI_MODE: "live", FOOJI_MAX_UPLOAD_SIZE_BYTES: "6291456", FOOJI_MAX_WAITING_TIME_MINUTES: "3", FOOJI_PUBLIC_LIBRARY: "true", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const $t = () => (console.log("Getting the domain for env ...", S.FOOJI_NODE_ENV), S.FOOJI_NODE_ENV === "development" ? (console.log("Getting the development domain ..."), S.FOOJI_MICROSITE_DOMAIN ?? document.location.host) : tt()), jt = {
  get: async () => {
    const t = $t(), { config: e } = await Lt(t);
    return e;
  }
};
async function Jt(t) {
  const e = `${c.serverlessFunctionsBaseUrl}/upload`, n = new FormData();
  return n.append("file", t), await (await l(e, {
    method: "POST",
    body: n
  }, void 0, {})).json();
}
const M = "6291456", v = ["image/jpeg", "image/png"], bt = (t) => {
  const { unit: e, value: n } = z(t);
  return `${n} ${e}`;
}, Vt = {
  save: (t) => v.includes(t.type) ? t.size > M ? Promise.reject(new Error(`File too large (Max: ${bt(M)})`)) : Jt(t) : Promise.reject(
    new Error(`Invalid file type: ${t.type} (Accepted types: ${v.join(", ")})`)
  )
}, Ht = async () => {
  const t = `${c.authApiBaseUrl}/me`;
  return (await (await l(t)).json()).me;
}, Gt = async (t) => {
  const e = `${c.authApiBaseUrl}/me`;
  return await (await l(e, {
    method: "PUT",
    body: JSON.stringify(t)
  })).json();
}, Kt = async (t) => {
  const e = `${c.frontendBaseUrl}/v1/user/settings`;
  return await (await l(e, {
    method: "POST",
    body: JSON.stringify({ settings: t })
  })).json();
}, Yt = (t) => ({
  ...q(t.metadata ?? {}, ["email_verified"]),
  first_name: t.first_name,
  last_name: t.last_name,
  email: t.email,
  phone: t.phone
}), Wt = {
  get: async () => {
    const t = await Ht();
    return t ? Yt(t) : void 0;
  },
  update: (t) => Gt(t)
}, xt = {
  save: (t) => Kt(t)
}, se = {
  Address: dt,
  Auth: vt,
  Campaign: Bt,
  CampaignUser: A,
  Config: jt,
  Upload: Vt,
  User: Wt,
  UserSettings: xt,
  Bugsnag: { notify: f }
};
export {
  se as default
};
